import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import { window } from '../../../../../globals';
import Loader from '../../../../generic/Loader';

import { CheckEmailStepBody } from './Google/ClaimDomainModal/CheckEmailStep';
import usePendingDomains from './hooks/usePendingDomains';
import useResendingEmailTokenIds from './hooks/useResendingEmailTokenIds';

type Props = {
  domain: string;
};

const CheckEmailModalBody: VoidFunctionComponent<Props> = ({ domain }) => {
  const organizationId = window.user?.organizationId as number;
  const { isLoading, value: pendingDomains } = usePendingDomains(window.user?.organizationId as number);
  const { resendEmailToken } = useResendingEmailTokenIds(organizationId);

  const resendVerificationEmail = useCallback(
    (authedDomain: string) => {
      const pendingToken = (pendingDomains || []).find(({ meta }) => meta.emailDomain === authedDomain);
      if (!pendingToken) {
        return null;
      }

      return resendEmailToken(pendingToken.id);
    },
    [pendingDomains, resendEmailToken],
  );

  return isLoading ? (
    <Loader />
  ) : (
    <CheckEmailStepBody
      domain={domain}
      resendEmail={() => {
        resendVerificationEmail(domain);
      }}
    />
  );
};

export default CheckEmailModalBody;
